import validationDeleteMateriel from '@/services/gabed/materiel/validationSuppression';

export default function validationDispositif(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  // Validation de la suppression des matériels
  validationDeleteMateriel(response, messages);

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('DISPOSITIF_USED_IN_QUOTE') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'dispositifPublicitaire.errors.dispositifInNQuote',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('DISPOSITIF_USED_IN_BILL') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'dispositifPublicitaire.errors.dispositifInNBill',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('DISPOSITIF_USED_IN_LOGISTIC_REQUEST') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'dispositifPublicitaire.errors.dispositifInNLogisticRequest',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('DISPOSITIF_USED_IN_ORDER') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'dispositifPublicitaire.errors.dispositifInNOrder',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('DISPOSITIF_USED_IN_OT_TECH') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'dispositifPublicitaire.errors.dispositifInNOtTech',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
    if (message.indexOf('DISPOSITIF_USED_IN_PRINT_REQUEST') === 0) {
      const elements = message.split('|')[0].split('@');
      messages.push({
        message: 'dispositifPublicitaire.errors.dispositifInNPrintRequest',
        parametres: {
          code: elements[1],
          qte: elements[2],
        },
      });
    }
  });
}
